<colmec-cart-list-buttons></colmec-cart-list-buttons>
<div class="row pb-2 pt-2 d-none d-md-flex cart-checkout-head">
  <div class="col-1 order-md-0"></div>
  <div class="col-1 order-md-0"></div>
  <div class="d-none d-md-block col-md-3 order-md-1 text-center">
    <b translate>ITEM</b>
  </div>
  <div class="col-4 col-md-2 order-md-2 text-center">
    <b translate>QUANTITY</b>
  </div>
  <div class="col-4 col-md-3 order-md-3 text-center">
    <b translate>NET_PRICE</b>
  </div>
  <div class="col-4 col-md-2 order-md-4 text-center">
    <b translate>TOTAL</b>
  </div>
</div>

<div class="row">
  <div *ngFor="let item of items" class="col-12">
    <ng-template libCustomHost></ng-template>
  </div>
</div>
